import config from '../../infra/config';
const HOST = config.USER_MGMT_API;

export default {
  getGenres: () => ({
    url: `${HOST}/tv/genres`,
  }),
  getNetworks: (channel) => ({
    url: ['hisense', 'peerlogix'].includes(channel)
      ? `${HOST}/tv/v2/networks/${channel}`
      : `${HOST}/tv/networks/${channel}`,
  }),
  getShows: (channel) => ({
    url: `${HOST}/tv/shows/${channel}`,
  }),
  getCommercials: (channel) => ({
    url: `${HOST}/tv/commercials/${channel}`,
  }),
  getCommercialsV2: (channel, payload) => ({
    url: `${HOST}/tv/v2/commercials/${channel}`,
    payload,
  }),
  getHierarchy: (channel) => ({
    url: `${HOST}/tv/hierarchy/${channel}`,
  }),
  getShowsMetadataByids: (ids, channel) => ({
    url: `${HOST}/tv/shows_by_ids/${channel}`,
    payload: { ids },
  }),
  getNielsenNetworksMap: () => ({
    url: `${HOST}/tv/nielsen_networks_map`,
  }),
  getNetworksShows: (networkIds, channel) => ({
    url: ['hisense', 'peerlogix'].includes(channel)
      ? `${HOST}/tv/v2/networks_shows/${channel}`
      : `${HOST}/tv/networks_shows/${channel}`,
    payload: { network_ids: networkIds },
  }),
  getKeyWords: (channel, queryParam, geo) => ({
    url: `${HOST}/tv/${channel}${geo ? `/${geo}` : ''}/commercials_keywords?${queryParam}`,
  }),
  getAdvancedGenres: () => ({
    url: `${HOST}/tv/advanced-genres`,
  }),
  getAdvancedNetworks: (channel, geo) => ({
    url: `${HOST}/tv/advanced-networks/${channel}${geo ? `/${geo}` : ''}`,
  }),
  getAdvancedShows: (channel, networks, genres, geo) => ({
    url: `${HOST}/tv/advanced/${channel}`,
    payload: { networks, genres, ...(geo ? { geo } : {}) },
  }),
  getAdvancedShowsBatch: (channel, viewingType, offset, limit, networks, genres, geo, sources) => ({
    url: `${HOST}/tv/v3/advanced/${channel}_${viewingType}`,
    payload: {
      networks,
      genres,
      limit,
      offset,
      ...(geo ? { geo } : {}),
      ...(sources?.length ? { sources } : {}),
    },
  }),
  searchAdvancedShows: (
    channel,
    viewingType,
    query,
    offset,
    limit,
    networks,
    genres,
    geo,
    scope,
    exactMatch,
    sources
  ) => ({
    url: `${HOST}/tv/v3/advanced-search/${channel}_${viewingType}`,
    /* eslint-disable-next-line camelcase */
    payload: {
      networks,
      genres,
      search_value: query,
      limit,
      offset,
      include_all_children_for_parent_match: true,
      ...(scope ? { scope } : {}),
      ...(exactMatch ? { exact_match: true } : {}),
      ...(geo ? { geo } : {}),
      ...(sources?.length ? { sources } : {}),
    },
  }),
};
